import Vue from '../../lib/utils/vue3compat/vue.js?vue3';
import VueRouter from '../../lib/utils/vue3compat/vue_router.js?vue3';
import { joinPaths, webIDEUrl } from '~/lib/utils/url_utility';
import { routes } from './routes.js?vue3';

Vue.use(VueRouter);

export function createRouter({ fullPath, defaultBranch, routerPath }) {
  if (defaultBranch) {
    // eslint-disable-next-line @gitlab/no-hardcoded-urls -- not ideal but acceptable in this case as there is no JavaScript path helper available
    window.gl.webIDEPath = webIDEUrl(joinPaths('/', fullPath, 'edit/', defaultBranch, '/-/'));
  }

  return new VueRouter({
    routes,
    mode: 'history',
    base: routerPath.replace(/\/work_items$/, ''),
  });
}
